import { useModal } from '../../../../hooks/use-modal';

type UseReportAgentModalReturnType = [
  ReturnType<typeof useModal>,
  ReturnType<typeof useModal>,
  (agentActive: boolean) => void,
];

export const useReportAgentModal = (): UseReportAgentModalReturnType => {
  const agentInactiveModal = useModal();
  const reportAgentModal = useModal();

  const openModal = (agentActive) => {
    if (agentActive) {
      reportAgentModal.openModal();
    } else {
      agentInactiveModal.openModal();
    }
  };

  return [agentInactiveModal, reportAgentModal, openModal];
};
